import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ngx-date-field',
  templateUrl: './date-field.component.html',
  styleUrls: ['./date-field.component.scss']
})
export class DateFieldComponent implements OnInit {

  @Input()
  datevalue: Date;

  @Input()
  dateformat: String;

  @Output()
  datevalueChange: EventEmitter<Date> = new EventEmitter();


  constructor() { }

  ngOnInit(): void {

  }

  onModelChange(event) {
    this.datevalueChange.emit(event);
  }

}
